import React from 'react';
import { Calendar, Clock, MapPin, Users } from 'lucide-react';
import type { Event } from '@/types/event';

const EventStats: React.FC<{ event: Event }> = ({ event }) => {
  const formatDate = (date: string | Date | undefined) => {
    if (!date) return 'TBD';
    return new Date(date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  };

  const formatTime = (date: string | Date | undefined) => {
    if (!date) return 'TBD';
    return new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 text-sm text-gray-300 mb-3 sm:mb-6">
      <div className="flex items-center">
        <Calendar size={14} className="mr-1 text-orange-300" />
        {formatDate(event.event_date)}
      </div>
      <div className="flex items-center">
        <Clock size={14} className="mr-1 text-orange-300" />
        {formatTime(event.event_date)}
        {" - "}
        {formatTime(event.event_end_date)}
      </div>
      <div className="flex items-center">
        <MapPin size={14} className="mr-1 text-orange-300" />
        {event.address?.venue || event.location || "Online"}
      </div>
      <div className="flex items-center">
        <Users size={14} className="mr-1 text-orange-300" />
        {event.registrations_count || "0"} registered
      </div>
    </div>
  );
};

export default EventStats;